import type { Validation } from './types/masonry-engine-node.types';
import type {
  ValidationHandler,
  MasonryEngineValidationHandlerMap,
} from './types/masonry-engine-validation.types';

export type RequiredValidation = Validation<'required', boolean>;
export type MinValidation = Validation<'min', number>;
export type MaxValidation = Validation<'max', number>;
export type MinLengthValidation = Validation<'minLength', number>;
export type MaxLengthValidation = Validation<'maxLength', number>;
export type PatternValidation = Validation<'pattern', string>;
export type DefaultValidation =
  | RequiredValidation
  | MinValidation
  | MaxValidation
  | MinLengthValidation
  | MaxLengthValidation
  | PatternValidation;

// Validate required fields
const RequiredValidationHandler: ValidationHandler<RequiredValidation> = (
  value,
  { required },
) => {
  if (required) {
    const isEmptyArray = Array.isArray(value) && value.length === 0;
    if (value === undefined || value === null || value === '' || isEmptyArray) {
      return false;
    }
  }
  return true;
};

// Validate minimum value for number fields
const MinValidationHandler: ValidationHandler<MinValidation> = (
  value,
  { min },
) => {
  // convert value to number before comparison
  const numericValue = Number(value);
  if (Number.isNaN(numericValue) || numericValue < min) {
    return false;
  }
  return true;
};

// Validate maximum value for number fields
const MaxValidationHandler: ValidationHandler<MaxValidation> = (
  value,
  { max },
) => {
  // convert value to number before comparison
  const numericValue = Number(value);
  if (Number.isNaN(numericValue) || numericValue > max) {
    return false;
  }
  return true;
};

// Validate minimum length for string fields or array fields like checkbox
const MinLengthValidationHandler: ValidationHandler<MinLengthValidation> = (
  value,
  { minLength },
) => {
  if (
    (typeof value === 'string' || Array.isArray(value)) &&
    value.length < minLength
  ) {
    return false;
  }
  return true;
};

// Validate maximum length for string fields  or array fields like checkbox
const MaxLengthValidationHandler: ValidationHandler<MaxLengthValidation> = (
  value,
  { maxLength },
) => {
  if (
    (typeof value === 'string' || Array.isArray(value)) &&
    value.length > maxLength
  ) {
    return false;
  }
  return true;
};

// Validate RegEx pattern for string fields
const PatternValidationHandler: ValidationHandler<PatternValidation> = (
  value,
  { pattern },
) => {
  if (typeof value !== 'string' || !new RegExp(pattern).test(value)) {
    return false;
  }
  return true;
};

export const masonryEngineDefaultValidationHandlerMap: MasonryEngineValidationHandlerMap<DefaultValidation> =
  {
    required: RequiredValidationHandler,
    minLength: MinLengthValidationHandler,
    maxLength: MaxLengthValidationHandler,
    min: MinValidationHandler,
    max: MaxValidationHandler,
    pattern: PatternValidationHandler,
  };
